import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('jewelry', false, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("circle", {
    "cx": "24",
    "cy": "24",
    "r": "20",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), _createVNode("path", {
    "d": "M20 24C20 17.6364 22.6275 15.3535 24 15C25.22 15.1768 28 17.2121 28 24C28 30.7879 25.22 33 24 33C22.6275 32.8232 20 30.3636 20 24Z",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth
  }, null), _createVNode("path", {
    "d": "M19.9995 23C18.4464 21.4625 13.6179 21.8399 12.0002 22C11.5149 23.7618 12.3521 27.4923 14.2934 29.4143C16.72 31.8167 18.6609 33 23.9995 33",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth
  }, null), _createVNode("path", {
    "d": "M28 23C29.4358 21.4669 33.5044 21.8403 35 22C35.2991 23.597 35.1402 27.1879 32.6276 29.8708C30.115 32.5537 25.5 33 24 33",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth
  }, null)]);
});